import { render, staticRenderFns } from "./UploadEditVideoWidget.vue?vue&type=template&id=49f27f5b&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./UploadEditVideoWidget.vue?vue&type=script&lang=js&"
export * from "./UploadEditVideoWidget.vue?vue&type=script&lang=js&"
import style0 from "./UploadEditVideoWidget.vue?vue&type=style&index=0&id=49f27f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f27f5b",
  null
  
)

export default component.exports